import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { CONTACT_LIST_FETCH, CONTACT_LIST_FETCH_FAILED, CONTACT_LIST_RECEIVE } from './contact-list-actions';
import { ContactListItem } from '../models/contact-list-item';

export interface ContactListReducerState {
    items: PaginatedResponse<ContactListItem>;
    requesting: boolean;
}

const initialContactListReducerState: ContactListReducerState = {
    items: { limit: 10, page: 0, total: 0, items: [] },
    requesting: false,
};

export const contactListReducer = (
    state: ContactListReducerState = initialContactListReducerState,
    action: AnyAction
): ContactListReducerState => {
    switch (action.type) {
        case CONTACT_LIST_FETCH: {
            return {
                ...state,
                requesting: true,
            };
        }

        case CONTACT_LIST_RECEIVE: {
            return {
                ...state,
                requesting: false,
                items: action['contacts'],
            };
        }

        case CONTACT_LIST_FETCH_FAILED: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
